export const SHOW_HIDE_PASSWORD_LANGUAGE = {
  english: { show: 'show password', hide: 'hide password' },
  spanish: { show: 'mostrar contraseña', hide: 'Contraseña oculta' },
  hindi: { show: 'पासवर्ड दिखाए', hide: 'पासवर्ड छिपाएं' }
};